export default __webpack_public_path__ + "static/media/Apple MacBook 12-inch.3d7b17bf.png";